
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import {Component, Prop, Vue} from "vue-property-decorator";
import {FormMix} from "@/UI/mixins/FormMix";
import {mixins} from "vue-class-component";
import {FormLayoutMix} from "@/UI/mixins/Layouts/Form";
import {OperationsMix} from "@/UI/mixins/Store/OperationsMix";
import moment from "moment";
import WriteOff from "@/UI/pages/Stores/Operations/WriteOff.vue";
import Sale from "@/UI/pages/Stores/Operations/Sale.vue";
import Arrival from "@/UI/pages/Stores/Operations/Arrival.vue";
import {FormRules, SaleProductFormData} from "@/form/Warehouse/Operations/SaleProductFormData";
import {getStudioId} from "@/UI/lib/state";
import {showNotification} from "@/UI/lib/messages";
import {OperationsStore} from "@/store/modules/Warehouse/Operations";

@Component({
    components: {
        BaseDataForm,
        WriteOff,
        Sale,
        Arrival
    },
    methods: {moment},
})
export default class ProductsOperations extends mixins(
    FormMix,
    OperationsMix,
    FormLayoutMix,
) {
    @Prop() mode!: number;
    forms = new SaleProductFormData();
    rules = FormRules
    disableCreateBtn = false;
    saving = false;

    get platformAdmin(): boolean {
        return Vue.auth.check('admin');
    }

    get canWrite(): boolean {
        return this.platformAdmin || (!this.disableCreateBtn && Vue.auth.check('owner') && [2, 3].includes(this.mode));
    }
    formReady = false;

    async saveCreate(mode?: number): Promise<void> {
        if (this.saving) return;
        this.rules.cashbox_id[0].required = mode === 3;
        this.rules.contractor_id[0].required = mode === 3;
        this.forms.need_pay = mode === 3;
        this.forms.storage_operation_type_id = this.$props['mode'];
        (this.$refs.OperationForm as any).$refs.OperationForm.validate(async (valid: any) => {
            if (valid && !this.saving) {
                this.saving = true;
                try {
                    this.forms.salon_id = Number(getStudioId(this))
                    await OperationsStore.create(this.forms).then(async (response: any) => {
                        this.$message.open({
                            type: response['status'] ? 'success' : 'error',
                            content: response.response
                        });
                        if(response['status']) {
                            await this.redirect(mode);
                        }
                    });
                } catch (e) {
                    this.$message.error(e.response?.data?.response || e.response?.data?.message || e.message);
                } finally {
                    this.saving = false;
                }
            }
        })
    }

    async update(mode?: number): Promise<void> {
        this.rules.cashbox_id[0].required = mode !== 2;
        if (mode === 3) {
            this.forms.need_pay = true;
        }
        (this.$refs.OperationForm as any).$refs.OperationForm.validate(async (valid: any) => {
            if (valid) {
                try {
                    this.formReady = false;
                    this.forms.salon_id = Number(getStudioId(this))
                    await OperationsStore.update(this.forms).then(async (response: any) => {
                        this.$message.open({
                            type: response['status'] ? 'success' : 'error',
                            content: response.response
                        });
                        /*if(response['status']) {
                            await this.redirect(mode);
                        }*/
                    });
                } catch (e) {
                    console.error(e)
                } finally {
                    this.formReady = true;
                }
            }
        })
    }

    async redirect(mode?: number): Promise<void> {
        if (mode === 3) {
            await Vue.router.push({
                name: String(this.$routeRules.StoreOperationsReport),
                params: {
                    Studio: String(this.forms.salon_id),
                    Data: JSON.stringify(this.forms),
                    mode: '2'
                },
            });
        } else {
            await Vue.router.push({
                name: String(this.$routeRules.StoreOperations),
                params: {
                    Studio: String(this.forms.salon_id),
                },
            });
        }
    }

    async created(): Promise<void> {
        this.formReady = true;

        if (this.$router.currentRoute.params["id"] !== '0') {
            this.disableCreateBtn = true;
        }
    }
}
